package ir.alirezaivaz.finglish.ui.theme

import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import finglish.composeapp.generated.resources.Res
import finglish.composeapp.generated.resources.montserrat_bold
import finglish.composeapp.generated.resources.montserrat_regular
import finglish.composeapp.generated.resources.vazirmatn_bold
import finglish.composeapp.generated.resources.vazirmatn_regular
import org.jetbrains.compose.resources.Font

@Composable
fun vazirmatnFontFamily() = FontFamily(
    Font(
        resource = Res.font.vazirmatn_regular,
        weight = FontWeight.Normal
    ),
    Font(
        resource = Res.font.vazirmatn_bold,
        weight = FontWeight.Bold
    ),
)

@Composable
fun vazirmatnTypography() = Typography().run {
    val vazirmatn = vazirmatnFontFamily()
    copy(
        displayLarge = displayLarge.copy(fontFamily = vazirmatn),
        displayMedium = displayMedium.copy(fontFamily = vazirmatn),
        displaySmall = displaySmall.copy(fontFamily = vazirmatn),
        headlineLarge = headlineLarge.copy(fontFamily = vazirmatn),
        headlineMedium = headlineMedium.copy(fontFamily = vazirmatn),
        headlineSmall = headlineSmall.copy(fontFamily = vazirmatn),
        titleLarge = titleLarge.copy(fontFamily = vazirmatn),
        titleMedium = titleMedium.copy(fontFamily = vazirmatn),
        titleSmall = titleSmall.copy(fontFamily = vazirmatn),
        bodyLarge = bodyLarge.copy(fontFamily = vazirmatn),
        bodyMedium = bodyMedium.copy(fontFamily = vazirmatn),
        bodySmall = bodySmall.copy(fontFamily = vazirmatn),
        labelLarge = labelLarge.copy(fontFamily = vazirmatn),
        labelMedium = labelMedium.copy(fontFamily = vazirmatn),
        labelSmall = labelSmall.copy(fontFamily = vazirmatn),
    )
}

@Composable
fun montserratFontFamily() = FontFamily(
    Font(
        resource = Res.font.montserrat_regular,
        weight = FontWeight.Normal
    ),
    Font(
        resource = Res.font.montserrat_bold,
        weight = FontWeight.Bold
    ),
)

@Composable
fun montserratTypography() = Typography().run {
    val montserrat = montserratFontFamily()
    copy(
        displayLarge = displayLarge.copy(fontFamily = montserrat),
        displayMedium = displayMedium.copy(fontFamily = montserrat),
        displaySmall = displaySmall.copy(fontFamily = montserrat),
        headlineLarge = headlineLarge.copy(fontFamily = montserrat),
        headlineMedium = headlineMedium.copy(fontFamily = montserrat),
        headlineSmall = headlineSmall.copy(fontFamily = montserrat),
        titleLarge = titleLarge.copy(fontFamily = montserrat),
        titleMedium = titleMedium.copy(fontFamily = montserrat),
        titleSmall = titleSmall.copy(fontFamily = montserrat),
        bodyLarge = bodyLarge.copy(fontFamily = montserrat),
        bodyMedium = bodyMedium.copy(fontFamily = montserrat),
        bodySmall = bodySmall.copy(fontFamily = montserrat),
        labelLarge = labelLarge.copy(fontFamily = montserrat),
        labelMedium = labelMedium.copy(fontFamily = montserrat),
        labelSmall = labelSmall.copy(fontFamily = montserrat),
    )
}
